module.exports = __webpack_public_path__ + "media/assets/img/products/studio_proofreading-selected-592cc3dc9e804d0761800bceaf9f4f36.svg";